import React from "react";
import TablaProducto from "./tablaProducto";
import TablaProveedores from "./tablaProveedores";
import Barra from "./barra";
import Cartas from "./cartas";
import Footer from "../../Footer";
export default function PanelAdministrativo() {
  const idFiscal = JSON.parse(localStorage.getItem("idefiscal"));
  const efiscalanio = JSON.parse(localStorage.getItem("efiscalanio"));
  return (
    <div className="bg-light m-auto p-auto">
      <div
        className="position-relative mb-2"
        style={{
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          borderRadius: "0 0 30px 30px",
          boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
        }}
      >
        <div className="container-fluid py-3">
          <div className="d-flex justify-content-between align-items-start flex-wrap gap-4">
            <div className="col-md-4">
              <h1 className="text-white fw-bold mb-2">
                <i className="fas fa-chart-pie me-3"></i>
                Análisis de Compras
              </h1>
              <p className="text-white-50 mb-0">
                Resumen de Compras Realizadas en el Año Fiscal {efiscalanio}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="col-md-12">
        <div className="my-4">
          <Cartas idFiscal={idFiscal} />
        </div>
        <div className="col-md-12 d-flex justify-content-between row p-0 m-auto">
          <div
            className="p-0 m-0"
            style={{
              width: "50%%",
            }}
          >
            <Barra />
          </div>
        </div>
        <div className="col-md-12 d-flex justify-content-between row p-0 mx-auto mt-4">
          <div
            className=" border-table p-0 m-0"
            style={{
              width: "49.9%",
            }}
          >
            <TablaProducto idFiscal={idFiscal} />
          </div>
          <div
            className="border-table p-0 m-0"
            style={{
              width: "49.9%",
            }}
          >
            <TablaProveedores idFiscal={idFiscal} />
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
